import { AuthActionType } from './auth-action.type';
export const initialState = {
    isAuthenticated: false,
    user: null,
};
export const authReducer = (state, action) => {
    switch (action.type) {
        case AuthActionType.SET_USER:
            return Object.assign(Object.assign({}, state), { user: action.payload, isAuthenticated: !!action.payload });
        case AuthActionType.LOGOUT_USER:
            return Object.assign(Object.assign({}, state), { user: null, isAuthenticated: false });
        default:
            return state;
    }
};
//# sourceMappingURL=auth-reducer.js.map